import { Customer } from "shared";

import { CustomerName } from "../pages/EditName/EditNamePage.types";
import { CustomerMailingAddress } from "../pages/EditMailingAddress/EditMailingAddressPage.types";
import { CustomerPhone } from "../pages/EditPhoneNumber/EditPhoneNumber.types";

type CustomerFields = CustomerName | CustomerMailingAddress | CustomerPhone;

const formFieldNames: (keyof Customer)[] = [
  "firstName",
  "middleName",
  "lastName",
  "line1",
  "line2",
  "city",
  "state",
  "postalCode",
  "phone",
];

/**
 * Checks if two customer objects have the same values
 */
export function areCustomersTheSame<T extends CustomerFields>(
  cust1: T,
  cust2: T
): boolean {
  return formFieldNames.every((key) => {
    if (key in cust1 && key in cust2) {
      return (
        String(cust1[key as keyof T]).trim() ===
        String(cust2[key as keyof T]).trim()
      );
    }

    return true;
  });
}
